export default __webpack_public_path__ + "static/media/otchet.fdbfa9df.svg";